export const LEFT_MARGIN = 75
export const RIGHT_MARGIN = 50
export const TOP_MARGIN = 30